(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/services/events.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/services/events.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.payment = svs.tur.payment || {};
svs.tur.payment.services = svs.tur.payment.services || {};
class Events {
  constructor() {
    this.callbacks = {};
    this.callback_once = {};
    this.log = new svs.core.log.Logger('Payment');
  }
  trigger(event, data) {
    if (!event) {
      svs.tur.payment.logger.warn('Missing property event for trigger()');
    } else {
      if (this.callbacks[event]) {
        this.callbacks[event].forEach(callback => {
          callback.callback.call(callback.context, data);
        });
      }
      if (this.callback_once[event]) {
        this.callback_once[event].forEach(callback => {
          callback.callback.call(callback.context, data);
          this.callback_once[event] = null;
        });
      }
    }
  }
  on(event, callback, context) {
    if (!this.callbacks[event]) {
      this.callbacks[event] = [];
    }
    this.callbacks[event].push({
      context,
      callback
    });
  }
  one(event, callback, context) {
    if (!this.callback_once[event]) {
      this.callback_once[event] = [];
    }
    this.callback_once[event].push({
      context,
      callback
    });
  }
  error(msg) {
    svs.tur.payment.logger.error(msg);
  }
  off(event, context) {
    if (this.callbacks[event]) {
      for (let i = 0; i < this.callbacks[event].length; i++) {
        const item = this.callbacks[event][i];
        if (item.context === context) {
          this.callbacks[event].splice(i, 1);
          break;
        }
      }
    }
  }
}
svs.tur.payment.services.Events = Events;

 })(window);